import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/gold.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-61aa2885")

_pushScopeId("data-v-61aa2885")
const _hoisted_1 = { class: "rank1" }
const _hoisted_2 = { class: "rank1-icon" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "gold-svg",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "ranking-name" }
const _hoisted_5 = { class: "score" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "user-score-span" }, "score", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Imgix = _resolveComponent("Imgix")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.path != '')
        ? (_openBlock(), _createBlock(_component_Imgix, {
            key: 0,
            class: "gold-img",
            imageUrl: _ctx.path,
            imageSize: _ctx.imageSize
          }, null, 8, ["imageUrl", "imageSize"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("p", _hoisted_4, _toDisplayString(_ctx.name), 1),
    _createVNode("p", _hoisted_5, [
      _createTextVNode(_toDisplayString(_ctx.score) + " ", 1),
      _hoisted_6
    ])
  ]))
})